import Constants from "../Constants";
import "../SCSS/DisplayErrorComponent.scss";
import CancelIcon from '@mui/icons-material/Cancel';

interface ErrorComponentProps {
  message: string | null | undefined;
}

const DisplayError: React.FC<ErrorComponentProps> = ({ message })=> {
  return (
    <div className="error-main-container">
      <div className="error-box">
        <div className="error-icon">
          <CancelIcon />
        </div>
        <p>{message ? message : Constants.ErrorText}</p>
      </div>
    </div>
  );
};
export default DisplayError;